<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>讨论答疑</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{  lessonInfo.manager &&  lessonInfo.manager ? lessonInfo.manager.name : '' }}</p>
        </div>
        <div class="course_btn">
          <div
            class="add-btn"
            v-show="false"
          >
          </div>
          <!-- <div class="add-btn">预览</div> -->
          <div
            v-if="lessonInfo.status==0"
            class="add-btn"
            @click="$parent.saveOnline(lessonInfo.title, lessonInfo.id)"
          >提交审核</div>
        </div>
      </div>
      <div id="list">
        <div class="title-wrap">
          <div class="top-box">
            <router-link
              class="top-title"
              to=""
            >{{discussObject.title}}</router-link>
            <!-- <div>
              点赞
            </div> -->
          </div>
          <div class="details">
            <p v-html="discussObject.content"></p>
          </div>
          <div class="item-tb">
            <span
              class="author"
              v-if="discussObject.createUser_id"
            >{{discussObject.createUser.name}}</span>
            <span
              class="time"
              v-if="discussObject.pubDate"
            >{{timeConversion(discussObject.pubDate)}}</span>
            <!-- <span class="sprite" @click="showDiscussWindow(0, discussObject)">回复</span> -->
          </div>
        </div>
        <!-- 回复数量 -->
        <div class="reply_count">
          共有<b>{{discussinfoCount}}</b>条回复
        </div>
        <!-- 评论回复列表 -->
        <div class="forumList">
          <!-- {{listData}} -->
          <div
            class="item-wrap"
            v-for="(item, index) in discussinfoData"
            :key="index"
          >
            <div
              class="item-list"
              v-if="item.discussType==0"
            >
              <div class="details">
                <p v-html="item.content"></p>
              </div>
              <div class="item-tb">
                <div>
                  <span class="author ">{{item.createUser}}</span>
                  <span
                    v-if="discussObject.pubDate"
                    class="minutes-ago"
                  >{{timeConversion(item.created)}}</span>
                </div>
                <div class="option">
                  <span
                    class="delete"
                    @click="askRelease(item.id)"
                  >删除</span>
                  <!-- <span class="publish" @click="showDiscussWindow(1, item)">回复</span>
                  <span @click="inParise(item.id)">
                    <img src="@/assets/images/lessonStudy/parise.png" alt="">
                    ({{item.count}})
                  </span> -->
                </div>
              </div>
            </div>
            <div
              class="item-list"
              v-else
            >
              <div class="details">
                <div class="quote">
                  <div class="blockquote">
                    <img
                      class="icon_quote_s"
                      src="@/assets/images/lessonStudy/icon_quote_s.gif"
                      alt=""
                    >
                    <span class="quote-user">{{item.userProfile.name}} 发表于 {{timeConversion(item.oriCreated)}}</span><br>
                    <p v-html="item.oriContent"></p>
                  </div>
                  <!-- <img class="icon_quote_e" src="@/assets/images/lessonStudy/icon_quote_e.gif" alt=""> -->
                </div>
                <p v-html="item.content"></p>
              </div>
              <div class="item-tb">
                <div>
                  <span class="author ">{{item.createUser}}</span>
                  <span
                    v-if="discussObject.pubDate"
                    class="minutes-ago"
                  >{{timeConversion(item.created)}}</span>
                </div>
                <div class="option">
                  <span
                    class="delete"
                    @click="askRelease(item.id)"
                  >删除</span>
                  <!-- <span class="publish" @click="showDiscussWindow(1, item)">回复</span> -->
                  <!-- <span @click="inParise(item.id)">
                    <img src="@/assets/images/lessonStudy/parise.png" alt="">
                    ({{item.count}})
                  </span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 讨论答疑 -->
    <div
      class="form_overlay"
      style="z-index: 1;"
      :style="classShowDiscussWindow"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel"
        style="width:780px"
      >
        <div class="form_title">帖子回复</div>
        <div class="form_content">
          <form id="itemForm">
            <div
              class="item"
              v-if="formData.discussType"
            >
              <div class="quote">
                <div class="blockquote">
                  <img
                    class="icon_quote_s"
                    src="@/assets/images/lessonStudy/icon_quote_s.gif"
                    alt=""
                  >
                  <span class="quote-user">{{formData.userProfile.name}} 发表于 {{timeConversion(formData.oriCreated)}}</span><br>
                  <p v-html="formData.oriContent"></p>
                </div>
                <!-- <img class="icon_quote_e" src="@/assets/images/lessonStudy/icon_quote_e.gif" alt=""> -->
              </div>
            </div>
            <div class="item">
              <vue-ueditor-wrap
                id="editor1"
                v-model="formData.content"
                :config="editorConfig"
                editor-id="editor-item1"
              ></vue-ueditor-wrap>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideDiscussWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="getStudentDiscuss()"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  components: {
    VueUeditorWrap
  },
  props: ['lessonInfo'],
  data() {
    return {
      editorConfig: {
        UEDITOR_HOME_URL: '/UE/',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        initialFrameWidth: '100%',
        initialFrameHeight: 300
      },
      discussObject: {},
      discussinfoData: [],
      discussinfoCount: 0,
      discussinfoInfo: {
        page: 1,
        size: 10000,
        onlineDiscuss_id: this.$route.query.discussId
      },
      classShowDiscussWindow: {},
      formData: {
        studentDiscuss_id: '',
        discussType: '',
        content: '',
        createUser: '',
        oriUser: '',
        oriContent: '',
        oriCreated: ''
      }
    }
  },

  methods: {
    showDiscussWindow(type, item) {
      // type 0 回复标题  1 回复评论信息
      this.formData.discussType = type
      this.formData.oriUser = type ? item.createUser : item.createUser.createUser
      this.formData.oriContent = item.content
      this.formData.oriCreated = type ? item.created : item.pubDate
      this.classShowDiscussWindow = {
        visibility: 'visible'
      }
    },
    hideDiscussWindow() {
      this.classShowDiscussWindow = {}
    },
    // 时间转换
    timeConversion(timestamp) {
      var a = new Date(timestamp).getTime()
      const date = new Date(a)
      const Y = date.getFullYear() + '-'
      const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '  '
      const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
      const dateString = Y + M + D + h + m
      return this.FunMinutesago(dateString)
    },
    // 计算时间间隔
    FunMinutesago(timestamp) {
      var dateTime = new Date(timestamp)
      var no1new = dateTime.valueOf()
      var year = dateTime.getFullYear()
      var month = dateTime.getMonth() + 1
      var day = dateTime.getDate()
      var now = new Date()
      var nowNew = now.valueOf()
      var milliseconds = 0
      var timeSpanStr
      milliseconds = nowNew - no1new
      if (milliseconds <= 1000 * 60 * 1) {
        timeSpanStr = '刚刚'
      } else if (1000 * 60 * 1 < milliseconds && milliseconds <= 1000 * 60 * 60) {
        timeSpanStr = Math.round((milliseconds / (1000 * 60))) + '分钟前'
      } else if (1000 * 60 * 60 * 1 < milliseconds && milliseconds <= 1000 * 60 * 60 * 24) {
        timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60)) + '小时前'
      } else if (1000 * 60 * 60 * 24 < milliseconds && milliseconds <= 1000 * 60 * 60 * 24 * 15) {
        timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60 * 24)) + '天前'
      } else if (milliseconds > 1000 * 60 * 60 * 24 * 15 && year === now.getFullYear()) {
        timeSpanStr = year + '-' + month + '-' + day
      } else {
        timeSpanStr = year + '-' + month + '-' + day
      }
      return timeSpanStr
    },
    // 获取讨论答疑信息
    async getOnlineDiscuss() {
      const url = '/online_discuss/' + this.$route.query.discussId + '/'
      await this.$http.get(url).then((data) => {
        this.discussObject = data
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取回复列表
    async getDiscussinfo() {
      await this.$http.get('/online_discuss_info/', {
        params: this.discussinfoInfo
      }).then((data) => {
        this.discussinfoData = data.results
        this.discussinfoCount = data.count
      }).catch(() => {
        this.$layer.msg('获取回复列表失败！')
      })
    },
    // 删除操作
    async askRelease(id) {
      const url = '/online_discuss_info/' + id + '/'
      await this.$parent.showConfirm('确认删除吗？', () => {
        this.$http.put(url, {
          isdel: 1
        }).then((data) => {
          this.$parent.showMsg('操作成功！')
          this.getDiscussinfo()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('操作失败！')
        })
      })
    }
  },
  mounted() {
    this.getDiscussinfo()
    this.getOnlineDiscuss()
  },
  computed: {
  }
}
</script>
<style scoped src="@/assets/css/project-detail.css"></style>
<style lang="less" scoped>
.panel-content {
  padding: 20px 40px;
}
.c-content {
  margin: 0;
  transform: translate(-50%, -50%);
}
.itemStatus {
  img {
    width: 120px;
  }
}
#c-panel {
  z-index: 2;
}
.c-content {
  min-height: 650px;
}
.active {
  color: #266dc7 !important;
  text-decoration: underline;
}
.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:last-child {
        color: #999;
        font-size: 16px;
      }
    }
  }
  .course_btn {
    div {
      margin-left: 20px;
      margin-bottom: 0;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
      &:first-child {
        background: #25c7a8;
      }
      &:nth-child(2) {
        border: 1px solid #73D6CA;
        color: #73D6CA;
        background: #fff;
      }
    }
  }
}
.add-btn {
  width: unset;
  height: unset;
  line-height: normal;
}
.add-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .item {
    .label {
      padding-left: 0;
    }
  }
}
.title-wrap {
  margin-bottom: 30px;
  border: 1px solid #eee;
  .top-box {
    background: #f9f9f9;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    .top-title {
      color: #333;
      font-size: 16px;
      height: 32px;
      line-height: 32px;
      &:hover {
        color: #009999;
      }
    }
    span {
      display: inline-block;
      height: 32px;
      color: #333;
      line-height: 32px;
      text-decoration: none !important;
      padding: 0 5px;
      cursor: pointer;
      text-align: center;
      &:hover {
        background: #ddd;
      }
    }
    .disHot {
      color: #cc0000;
    }
  }
  .details {
    color: #666;
    display: block;
    padding: 20px;
    line-height: 22px;
  }
  .item-tb {
    height: 20px;
    padding: 0 20px 20px;
    overflow: hidden;
    span {
      display: inline-block;
    }
    .author {
      color: #555;
      text-decoration: underline;
      margin-right: 20px;
    }
    .time {
      font-size: 13px;
      color: #999;
    }
    .sprite {
      background: #1a61ab;
      color: #fff;
      float: right;
      height: 31px;
      line-height: 34px;
      margin-top: -3px;
      text-align: center;
      width: 60px;
      cursor: pointer;
    }
  }
}
.reply_count {
  background: #f9f9f9;
  border: 1px solid #eee;
  padding: 15px 20px;
  position: relative;
  margin: 25px 0 0;
  b {
    font-weight: normal;
    margin: 0 5px;
  }
}
.quote {
  margin: 10px 0;
  background: #f7f7f7;
  padding: 15px 10px 18px 60px;
  color: #999;
  position: relative;
  .icon_quote_s {
    position: absolute;
    left: 20px;
  }
  .blockquote {
    display: inline;
    line-height: 1.6;
    padding: 0 68px 18px 0;
    color: #444;
    font-size: 14px;
    // background: url('../../assets/images/lessonStudy/icon_quote_e.gif') no-repeat scroll 50% 100%;
  }
  p {
    display: inline-block;
    color: #444444;
    padding-right: 20px;
  }
}
.forumList {
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  .item-list {
    border-bottom: 1px solid #eee;
    padding-bottom: 8px;
    .details {
      color: #666;
      display: block;
      padding: 20px;
      line-height: 22px;
      p {
        margin: 0 0 10px;
      }
    }
    .item-tb {
      padding: 0 20px 10px;
      display: flex;
      justify-content: space-between;
      .author {
        color: #555;
        text-decoration: underline;
        margin-right: 20px;
      }
      .option {
        span {
          display: inline-block;
          height: 32px;
          color: #333;
          line-height: 32px;
          text-decoration: none !important;
          padding: 0 10px !important;
          cursor: pointer;
          text-align: center;
          &:hover {
            background: #ddd;
          }
        }
        img {
          position: relative;
          top: 4px;
          width: 20px;
        }
      }
    }
  }
}
</style>
